const constants = {
  ROOT_ELEMENT: document.querySelector("#root"),
  STATE_MANAGEMENT: {
    AUXILIARY: "bank-albilad/auxiliary",
  },
  COLORS: {
    PRIMARY: "#d2202f",
    SECONDARY: "#f8b332",
    DARK: "#2b2e34",
    DARK_GRAY: "#6E6861",
  },
};

export default constants;
